import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const GREEN = "#1F3A30";
const GREEN2 = "#24453A";
const SAGE = "#8FA89F";
const IVORY = "#F2EDE3";
const PAPER = "#F8F4EA";
const TAUPE = "#7A6552";
const GOLD = "#C9A44B";
const INK = "#1A1712";
const WHATSAPP_LINK = "https://wa.me/393497173896?text=Ciao%20Alex%2C%20vorrei%20costruire%20la%20mia%20liquidazione%20personale%20in%20oro%20fisico";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const RICONTATTO = "Ti contatto io personalmente, su WhatsApp o per telefono, entro 24 ore lavorative.";

const TESTIMONIALS = [
  { text: "Alex si è dimostrato estremamente serio e professionale. La sua profonda conoscenza dell'oro offre una prospettiva solida: un modo concreto per dare stabilità ai propri risparmi. Lo consiglio vivamente.", name: "Marco", role: "Imprenditore con SRL" },
  { text: "Sempre disponibile e professionale, si distingue per gentilezza e affidabilità: lavora con impegno e passione. Consigliato per chi cerca qualità e serietà.", name: "Roberto", role: "Imprenditore nel settore abbigliamento e moda" },
  { text: "Si capisce subito che sei un professionista. Competenza e serietà fuori dal comune.", name: "Alessandro", role: "Titolare di uno studio di geometri" },
];

const VIDEOS = [
  { id: "tarcisio", cap: "Tarcisio, Difensore Condominiale" },
  { id: "francesco", cap: "Francesco, imprenditore edile" },
  { id: "alessia", cap: "Alessia, Amministratrice" },
  { id: "roberto", cap: "Roberto, Imprenditore", subs: true },
];

const STEPS = [
  { n: "01", t: "Partiamo da te.", b: "Obiettivi, orizzonte temporale e liquidità da mantenere disponibile." },
  { n: "02", t: "Valutiamo il percorso.", b: "Comprendere se l'oro fisico è adatto e valutare acquisto iniziale, accumulo periodico o entrambe le modalità." },
  { n: "03", t: "Ti accompagno nel tempo.", b: "Confronti per rivedere il percorso quando cambiano esigenze e disponibilità." },
];

const MODES = [
  { t: "Acquisto iniziale", b: "Destini all'oro fisico una parte degli utili, in un'unica soluzione." },
  { t: "Accumulo periodico", b: "Costruisci la riserva un passo alla volta, con un ritmo sostenibile per te." },
  { t: "Combinazione", b: "Parti con un acquisto iniziale e prosegui con un accumulo nel tempo." },
];

const CLARITY = ["Valore", "Metodo", "Proprietà", "Custodia", "Rivendita"];

const RISKS = [
  "Il prezzo dell'oro può oscillare e anche scendere, pure per periodi lunghi.",
  "Costi e differenza tra prezzo di acquisto e prezzo di vendita incidono sul risultato finale.",
  "Non sono garantiti rendimenti né la conservazione del capitale.",
  "L'adeguatezza del percorso va valutata sulla tua situazione personale.",
];


const CSS = `
.mk{background:${IVORY};color:${INK};font-family:'Poppins',sans-serif;line-height:1.65;-webkit-font-smoothing:antialiased;overflow-x:hidden;}
.mk *{box-sizing:border-box;}
.mk h1,.mk h2,.mk h3{font-family:'Lora',serif;font-weight:600;line-height:1.18;margin:0;}
.mk :where(p){margin:0;}
.mk-w{max-width:1080px;margin:0 auto;padding:0 22px;}
.mk-n{max-width:720px;margin-left:auto;margin-right:auto;}
.mk-sec{padding:72px 0;}
.mk-green{background:${GREEN};color:${IVORY};}
.mk-sage{background:${SAGE};color:${GREEN};}
.mk-paper{background:${PAPER};}
.mk-eb{display:flex;align-items:center;justify-content:center;gap:12px;font-size:12px;letter-spacing:3.5px;text-transform:uppercase;font-weight:600;color:${TAUPE};margin-bottom:18px;}
.mk-eb:before,.mk-eb:after{content:"";width:28px;height:1px;background:currentColor;opacity:.6;}
.mk-green .mk-eb{color:${GOLD};}
.mk-sage .mk-eb{color:${GREEN};}
.mk-h2{font-size:clamp(28px,4.2vw,42px);text-align:center;color:${GREEN};text-wrap:balance;}
.mk-h2 em{font-style:italic;color:#9C7B2C;font-weight:500;}
.mk-green .mk-h2{color:${IVORY};}
.mk-green .mk-h2 em{color:${GOLD};}
.mk-sage .mk-h2 em{color:${GREEN};}
.mk-lead{font-size:18px;text-align:center;margin-top:22px;color:#2E2A23;text-wrap:pretty;}
.mk-green .mk-lead{color:rgba(242,237,227,.88);}
.mk-sage .mk-lead{color:${GREEN};}
.mk-lead+.mk-lead{margin-top:14px;}

.mk-btn{display:inline-flex;align-items:center;justify-content:center;gap:10px;background:${GOLD};color:${GREEN};font-weight:600;font-size:16px;text-decoration:none;padding:16px 34px;border-radius:999px;border:0;cursor:pointer;font-family:'Poppins',sans-serif;white-space:nowrap;transition:transform .2s ease,box-shadow .2s ease,opacity .2s ease;box-shadow:0 10px 26px rgba(201,164,75,.22);}
.mk-btn:hover{transform:translateY(-2px);box-shadow:0 14px 30px rgba(201,164,75,.32);}
.mk-btn:disabled{opacity:.6;cursor:default;transform:none;}
.mk-link{color:inherit;text-decoration:underline;text-decoration-color:rgba(201,164,75,.7);text-underline-offset:4px;transition:color .2s ease;}
.mk-link:hover{color:${GOLD};}

.mk-hero{background:${GREEN};background-image:radial-gradient(ellipse at 20% -10%, rgba(201,164,75,.2), transparent 60%);color:${IVORY};padding:64px 0 72px;}
.mk-hero-grid{display:grid;gap:44px;align-items:center;}
.mk-hero-txt{text-align:center;}
.mk-hero-badge{display:inline-block;font-size:clamp(11px,3.1vw,14px);font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:${GOLD};border:1px solid rgba(201,164,75,.7);border-radius:999px;padding:.6em 1.2em;margin-bottom:26px;background:rgba(201,164,75,.06);line-height:1.5;}
.mk-hero-badge .nw{white-space:nowrap;}
.mk-hero-badge .sep{display:block;height:0;overflow:hidden;}
@media (min-width:600px){.mk-hero-badge .sep{display:inline;height:auto;}}
.mk-hero h1{font-size:clamp(32px,5.2vw,58px);color:${IVORY};text-wrap:balance;letter-spacing:-.3px;}
.mk-hero h1 em{display:block;font-style:italic;color:${GOLD};font-weight:500;margin-top:6px;}
.mk-hero .mk-sub{font-size:clamp(16px,1.5vw,19px);color:rgba(242,237,227,.88);max-width:560px;margin:24px auto 0;text-wrap:pretty;}
.mk-hero-cta{margin-top:34px;display:flex;flex-direction:column;align-items:center;gap:12px;}
.mk-hero-note{font-size:14px;color:rgba(242,237,227,.78);}
.mk-hero-calc{font-size:14px;color:rgba(242,237,227,.78);margin-top:22px;}
.mk-hero-photo{position:relative;max-width:300px;width:100%;margin:0 auto;}
.mk-hero-photo:before{content:"";position:absolute;inset:16px -16px -16px 16px;border:1.5px solid ${GOLD};border-radius:20px;}
.mk-hero-photo img{position:relative;width:100%;display:block;border-radius:20px;box-shadow:0 24px 50px rgba(0,0,0,.35);}

.mk-quote{max-width:720px;margin:34px auto 0;padding:22px 26px;border-left:2px solid ${GREEN};background:rgba(242,237,227,.45);border-radius:0 12px 12px 0;font-size:15px;color:${GREEN};}

.mk-steps{display:grid;gap:18px;margin-top:46px;}
.mk-step{background:#fff;border:1px solid rgba(122,101,82,.22);border-top:3px solid ${GOLD};border-radius:16px;padding:30px 26px;transition:transform .25s ease,box-shadow .25s ease;}
.mk-step:hover{transform:translateY(-4px);box-shadow:0 18px 40px rgba(31,58,48,.10);}
.mk-step .n{font-family:'Lora',serif;font-size:44px;color:${GOLD};line-height:1;font-weight:500;}
.mk-step h3{font-size:22px;color:${GREEN};margin-top:16px;}
.mk-step p{font-size:16px;color:#3A352C;margin-top:10px;}
.mk-modes-t{font-family:'Lora',serif;font-size:20px;color:${GREEN};text-align:center;margin-top:56px;}
.mk-modes{display:grid;gap:12px;margin-top:20px;}
.mk-mode{border:1px solid rgba(122,101,82,.28);border-radius:14px;padding:20px 22px;background:rgba(255,255,255,.55);}
.mk-mode h3{font-size:18px;color:#9C7B2C;}
.mk-mode p{font-size:15px;color:#3A352C;margin-top:6px;}
.mk-motto{font-family:'Lora',serif;font-style:italic;font-size:clamp(22px,3vw,30px);color:${GREEN};text-align:center;max-width:760px;margin:60px auto 0;text-wrap:balance;line-height:1.35;}
.mk-motto:before{content:"";display:block;width:48px;height:2px;background:${GOLD};margin:0 auto 22px;}

.mk-clar{margin-top:40px;border:1px solid rgba(201,164,75,.45);border-radius:16px;padding:26px;}
.mk-clar h3{font-size:19px;color:${IVORY};text-align:center;}
.mk-clar ul{list-style:none;padding:0;margin:18px 0 0;display:flex;flex-wrap:wrap;justify-content:center;gap:10px;}
.mk-clar li{border:1px solid rgba(201,164,75,.4);color:${IVORY};border-radius:999px;padding:7px 16px;font-size:14px;}
.mk-clar li.mk-br{display:none;}
.mk-risk{margin-top:22px;background:${GREEN2};border:1px solid rgba(201,164,75,.3);border-radius:16px;padding:26px;}
.mk-risk h3{font-size:19px;color:${GOLD};}
.mk-risk ul{margin:14px 0 0;padding-left:20px;}
.mk-risk li{color:rgba(242,237,227,.88);font-size:15.5px;margin-top:8px;}
.mk-risk li::marker{color:${GOLD};}
.mk-mid-cta{text-align:center;margin-top:40px;}

.mk-videos{display:flex;flex-direction:column;align-items:center;gap:28px;margin-top:46px;}
.mk-video{width:100%;}
.mk-video .vq{font-family:'Lora',serif;font-style:italic;font-size:15px;color:#3A352C;text-align:center;margin-top:6px;line-height:1.5;}
.mk-video video::cue{background:rgba(0,0,0,.72);color:#fff;font-family:'Poppins',sans-serif;font-size:15px;line-height:1.35;}
.mk-video video{width:100%;aspect-ratio:9/16;background:#000;border-radius:16px;border:1px solid rgba(201,164,75,.4);display:block;object-fit:cover;}
.mk-video .cap{text-align:center;font-size:15px;color:${GREEN};margin-top:12px;font-weight:500;}
.mk-testi{display:grid;gap:16px;margin-top:40px;}
.mk-tc{background:#fff;border:1px solid rgba(122,101,82,.22);border-radius:16px;padding:26px;}
.mk-tc .q{font-family:'Lora',serif;font-size:44px;line-height:.6;color:${GOLD};}
.mk-tc .tx{font-family:'Lora',serif;font-style:italic;color:${INK};font-size:17px;margin-top:12px;}
.mk-tc .nm{color:${GREEN};font-weight:600;margin-top:16px;}
.mk-tc .rl{color:${TAUPE};font-size:14px;}
.mk-clients{text-align:center;margin-top:40px;font-family:'Lora',serif;font-size:20px;color:${GREEN};}
.mk-clients b{color:#9C7B2C;font-weight:600;}

.mk-about-grid{max-width:980px;margin:40px auto 0;display:grid;gap:32px;}
.mk-about-photo{margin:0 auto;width:100%;max-width:400px;aspect-ratio:4/5;border:1px solid ${GOLD};border-radius:12px;overflow:hidden;box-shadow:0 18px 40px rgba(31,58,48,.18);}
.mk-about-photo img{width:100%;height:100%;object-fit:cover;object-position:center;display:block;}
.mk-about{max-width:760px;margin:0 auto;}
.mk-about p{font-size:17px;color:${INK};}
.mk-about p+p{margin-top:16px;}
.mk-sign{font-family:'Lora',serif;font-style:italic;font-size:22px;color:${GREEN};margin-top:22px;}
.mk-stats{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-top:30px;}
.mk-stat{border-top:2px solid ${GOLD};padding-top:12px;}
.mk-stat .v{font-family:'Lora',serif;font-size:clamp(22px,3vw,30px);color:${GREEN};font-weight:600;line-height:1.1;}
.mk-stat .l{font-size:13px;color:${TAUPE};margin-top:4px;line-height:1.4;}


.mk-final{background:${GREEN};background-image:radial-gradient(ellipse at 50% 110%, rgba(201,164,75,.2), transparent 60%);color:${IVORY};padding:88px 0 56px;}
.mk-final h2{font-size:clamp(28px,4.4vw,46px);color:${IVORY};text-align:center;text-wrap:balance;}
.mk-final .mk-sub{font-size:18px;color:rgba(242,237,227,.88);max-width:620px;margin:22px auto 0;text-align:center;}
.mk-form{max-width:520px;margin:40px auto 0;background:${GREEN2};border:1px solid rgba(201,164,75,.38);border-radius:20px;padding:28px 24px;display:grid;gap:14px;}
.mk-form label.f{display:grid;gap:6px;font-size:14px;color:rgba(242,237,227,.85);}
.mk-form input[type=text],.mk-form input[type=tel],.mk-form textarea{width:100%;background:rgba(0,0,0,.18);border:1px solid rgba(242,237,227,.25);border-radius:10px;padding:13px 14px;color:${IVORY};font-family:'Poppins',sans-serif;font-size:16px;transition:border-color .2s ease;}
.mk-form input:focus,.mk-form textarea:focus{outline:none;border-color:${GOLD};}
.mk-form textarea{min-height:92px;resize:vertical;}
.mk-form .opt{color:rgba(242,237,227,.55);font-size:12px;}
.mk-form .chk{display:flex;gap:10px;align-items:flex-start;font-size:13px;color:rgba(242,237,227,.8);cursor:pointer;}
.mk-form .chk input{margin-top:3px;accent-color:${GOLD};width:16px;height:16px;flex:none;}
.mk-form .chk a{color:${GOLD};}
.mk-form .mk-btn{width:100%;margin-top:4px;}
.mk-form .err{color:#F3B4A6;font-size:14px;}
.mk-form .how{font-size:13px;color:rgba(242,237,227,.72);text-align:center;}
.mk-ok{max-width:520px;margin:40px auto 0;background:${GREEN2};border:1px solid ${GOLD};border-radius:20px;padding:34px 26px;text-align:center;}
.mk-ok h3{font-size:24px;color:${GOLD};}
.mk-ok p{margin-top:12px;color:rgba(242,237,227,.9);}
.mk-alt{text-align:center;margin-top:26px;font-size:15px;color:rgba(242,237,227,.8);display:grid;gap:8px;}
.mk-disc{font-size:12px;color:#B8C7BF;max-width:640px;margin:56px auto 0;line-height:1.7;border-top:1px solid rgba(201,164,75,.25);padding-top:22px;text-align:center;}

@media (max-width:374px){ .mk-btn{font-size:15px;padding-left:22px;padding-right:22px;} }
@media (min-width:720px){
  .mk-steps{grid-template-columns:repeat(3,1fr);}
  .mk-modes{grid-template-columns:repeat(3,1fr);}
  .mk-clar li.mk-br{display:block;flex-basis:100%;height:0;border:0;padding:0;}
  .mk-videos{display:grid;grid-template-columns:repeat(2,minmax(0,280px));justify-content:center;align-items:start;gap:28px;}
  .mk-testi{grid-template-columns:repeat(3,1fr);}
  .mk-sec{padding:96px 0;}
  .mk-form{padding:34px 32px;}
}
@media (min-width:1024px){
  .mk-videos{grid-template-columns:repeat(4,minmax(0,1fr));gap:20px;}
}
@media (min-width:900px){
  .mk-about-grid{grid-template-columns:380px 1fr;gap:56px;align-items:center;}
  .mk-about-photo{max-width:none;}
}
@media (min-width:960px){
  .mk-hero{padding:96px 0 104px;}
  .mk-hero-grid{grid-template-columns:1fr 340px;gap:72px;}
  .mk-hero-txt{text-align:left;}
  .mk-hero .mk-sub{margin-left:0;}
  .mk-hero-cta{align-items:flex-start;}
  .mk-hero-photo{max-width:340px;}
}
`;

// Provenienza come nel calcolatore: UTM in URL (salvata in sessione), altrimenti quella di sessione, altrimenti Diretto
function metodoProvenienza() {
  try {
    const p = new URLSearchParams(window.location.search);
    const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
    const src = (p.get("utm_source") || "").trim();
    if (src) {
      const prov = [cap(src), (p.get("utm_medium") || "").trim(), (p.get("utm_campaign") || "").trim()].filter(Boolean).join(" · ");
      sessionStorage.setItem("ag_prov", prov);
      return prov;
    }
    return sessionStorage.getItem("ag_prov") || "Diretto";
  } catch {
    return "Diretto";
  }
}

// Conteggio anonimo: una sola volta per sessione e per tipo, nessun dato personale
function trackMetodo(tipo) {
  try {
    const key = `ag_m_${tipo}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    fetch(`${API}/metodo/track`, {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ tipo, provenienza: metodoProvenienza() }),
    }).catch(() => {});
  } catch { /* noop */ }
}

const Eyebrow = ({ children }) => <span className="mk-eb">{children}</span>;
const CtaBtn = ({ id }) => <a href="#contatto" className="mk-btn" data-testid={id}>Parliamo del tuo progetto</a>;

function Hero({ calcHref }) {
  return (
    <header className="mk-hero" data-testid="metodo-hero">
      <div className="mk-w mk-hero-grid">
        <div className="mk-hero-txt">
          <span className="mk-hero-badge" data-testid="metodo-hero-badge"><span className="nw">Metodo Alex Gold</span><span className="sep"> · </span><span className="nw">Per professionisti e Partite IVA</span></span>
          <h1 data-testid="metodo-hero-title">Hai costruito la tua attività. <em>Ora costruisci qualcosa anche per te.</em></h1>
          <p className="mk-sub">Un percorso personalizzato per valutare come destinare parte degli utili a una riserva personale in oro fisico, con scelte sostenibili e accompagnamento nel tempo.</p>
          <div className="mk-hero-cta">
            <CtaBtn id="metodo-hero-cta-btn" />
            <p className="mk-hero-note" data-testid="metodo-hero-note">Primo confronto gratuito, senza impegno.</p>
          </div>
          <p className="mk-hero-calc">Vuoi partire dai numeri? <a href={calcHref} onClick={() => trackMetodo("calcolatore")} className="mk-link" data-testid="metodo-calcolatore-btn">Prova il calcolatore gratuito.</a></p>
        </div>
        <div className="mk-hero-photo"><img src="/images/alex.jpg" alt="Alex Gold" loading="eager" data-testid="metodo-hero-photo" /></div>
      </div>
    </header>
  );
}

function Bisogno() {
  return (
    <section className="mk-sec" data-testid="metodo-bisogno">
      <div className="mk-w mk-n">
        <Eyebrow>Il tuo progetto personale</Eyebrow>
        <h2 className="mk-h2">La tua attività ha un piano. <em>Il tuo futuro personale?</em></h2>
        <p className="mk-lead">Tra clienti, scadenze e investimenti, gran parte di ciò che guadagni torna nel lavoro. Intanto resta una domanda: quando rallenterò, cosa avrò costruito per me?</p>
        <p className="mk-lead">Per chi lavora in proprio, una liquidazione personale è un progetto da organizzare. Il Metodo Alex Gold ti aiuta a valutare quale spazio può avere l'oro fisico in questo progetto.</p>
        <p className="mk-quote" data-testid="metodo-concetto-nota">"Liquidazione personale" è un'espressione figurata: non è un TFR in senso giuridico, né un prodotto previdenziale.</p>
      </div>
    </section>
  );
}

function ComeFunziona() {
  return (
    <section className="mk-sec mk-paper" id="metodo" data-testid="metodo-fasi">
      <div className="mk-w">
        <Eyebrow>Come funziona il metodo</Eyebrow>
        <h2 className="mk-h2">Un progetto costruito <em>sulla tua situazione.</em></h2>
        <div className="mk-steps">
          {STEPS.map((s) => (
            <div className="mk-step" key={s.n} data-testid={`metodo-fase-${s.n}`}>
              <div className="n">{s.n}</div>
              <h3>{s.t}</h3>
              <p>{s.b}</p>
            </div>
          ))}
        </div>
        <p className="mk-modes-t">Le modalità che valutiamo insieme</p>
        <div className="mk-modes" data-testid="metodo-modalita">
          {MODES.map((m, i) => (
            <div className="mk-mode" key={m.t} data-testid={`metodo-modo-${i}`}>
              <h3>{m.t}</h3>
              <p>{m.b}</p>
            </div>
          ))}
        </div>
        <p className="mk-motto" data-testid="metodo-motto">Non ti dico di comprare oro. Ti aiuto a capire se ha senso per te.</p>
      </div>
    </section>
  );
}

function Accompagnamento() {
  return (
    <section className="mk-sec mk-green" data-testid="metodo-accompagnamento">
      <div className="mk-w">
        <Eyebrow>Il valore dell'accompagnamento</Eyebrow>
        <h2 className="mk-h2">Sapere cosa stai facendo. <em>E perché.</em></h2>
        <p className="mk-lead mk-n">Prima di qualsiasi scelta ti aiuto a comprendere, con parole semplici, come funzionano le modalità di acquisto, quali costi considerare, dove e come viene custodito l'oro e come funziona la successiva vendita. Così decidi con serenità e consapevolezza.</p>
        <div className="mk-clar mk-n" data-testid="metodo-chiarezza">
          <h3>Prima di procedere, avrai chiari:</h3>
          <ul data-testid="metodo-chiarezza-pills">
            {CLARITY.map((c, i) => [
              <li key={c} data-testid={`metodo-pill-${i}`}>{c}</li>,
              i === 2 ? <li key="br" className="mk-br" aria-hidden="true" /> : null,
            ])}
          </ul>
        </div>
        <div className="mk-risk mk-n" data-testid="metodo-rischi">
          <h3>Cosa è importante sapere</h3>
          <ul>{RISKS.map((r) => <li key={r}>{r}</li>)}</ul>
        </div>
        <div className="mk-mid-cta"><CtaBtn id="metodo-mid-cta-btn" /></div>
      </div>
    </section>
  );
}

function Testimonianze() {
  return (
    <section className="mk-sec" data-testid="metodo-testimonianze">
      <div className="mk-w">
        <Eyebrow>Testimonianze</Eyebrow>
        <h2 className="mk-h2">Chi ha iniziato aveva <em>domande simili alle tue.</em></h2>
        <div className="mk-videos">
          {VIDEOS.map((v) => (
            <div className="mk-video" key={v.id}>
              <video controls playsInline preload="none" poster={`/videos/${v.id}-poster.jpg`} data-testid={`metodo-video-${v.id}`}>
                <source src={`/videos/${v.id}.mp4`} type="video/mp4" />
                {v.subs && <track kind="subtitles" src={`/videos/${v.id}-it.vtt`} srcLang="it" label="Italiano" default />}
              </video>
              <div className="cap" data-testid={`metodo-video-cap-${v.id}`}>{v.cap}</div>
              {v.quote && <p className="vq" data-testid={`metodo-video-quote-${v.id}`}>"{v.quote}"</p>}
            </div>
          ))}
        </div>
        <div className="mk-testi">
          {TESTIMONIALS.map((t, i) => (
            <div className="mk-tc" key={t.name} data-testid={`metodo-testi-${i}`}>
              <div className="q">"</div>
              <p className="tx">{t.text}</p>
              <p className="nm">{t.name}</p>
              <p className="rl">{t.role}</p>
            </div>
          ))}
        </div>
        <p className="mk-clients" data-testid="metodo-clienti">Oltre <b>150 clienti</b> hanno scelto di affidarsi a me.</p>
      </div>
    </section>
  );
}

function ChiTiAccompagna() {
  return (
    <section className="mk-sec mk-sage" data-testid="metodo-chisono">
      <div className="mk-w">
        <Eyebrow>Chi ti accompagna</Eyebrow>
        <h2 className="mk-h2">Prima del metodo, <em>una persona con cui confrontarti.</em></h2>
        <div className="mk-about-grid">
          <figure className="mk-about-photo" data-testid="metodo-chisono-photo">
            <img src="/images/alex-intervento.jpg" alt="Alex Gold durante un incontro con professionisti" loading="lazy" width="540" height="675" />
          </figure>
        <div className="mk-about">
          <p>Per 26 anni ho lavorato da dipendente, con una liquidazione che maturava nel tempo. Quando ho iniziato a lavorare in proprio ho capito che quel progetto, da quel momento, dovevo costruirlo io.</p>
          <p>Da 10 anni lavoro nel settore dell'oro e collaboro con operatori autorizzati OAM. Ho scelto di affiancare professionisti e Partite IVA perché conosco da vicino le loro giornate: tanto lavoro per gli altri, poco tempo per pensare a sé.</p>
          <p>Il mio ruolo è aiutarti a fare chiarezza, con calma e con parole semplici, perché ogni scelta sia davvero tua.</p>
          <p className="mk-sign">Alex</p>
          <div className="mk-stats" data-testid="metodo-stats">
            <div className="mk-stat"><div className="v">26 anni</div><div className="l">da dipendente</div></div>
            <div className="mk-stat"><div className="v">10 anni</div><div className="l">nel settore dell'oro</div></div>
            <div className="mk-stat"><div className="v">150+</div><div className="l">clienti</div></div>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
}


function ContactForm() {
  const [form, setForm] = useState({ nome: "", telefono: "", domanda: "", privacy: false });
  const [err, setErr] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const nome = form.nome.trim();
    const tel = form.telefono.trim();
    if (!nome) return setErr("Inserisci il tuo nome.");
    if (tel.replace(/\D/g, "").length < 8) return setErr("Inserisci un numero di telefono valido.");
    if (!form.privacy) return setErr("Per inviare la richiesta serve il consenso all'informativa privacy.");
    setErr("");
    setSending(true);
    try {
      const domanda = form.domanda.trim();
      await axios.post(`${API}/leads`, {
        tipo: "cliente",
        nome,
        email: "",
        telefono: tel,
        messaggio: `[Metodo] Richiesta primo confronto${domanda ? ` — Cosa vorresti costruire per te: ${domanda}` : ""}`,
        provenienza: metodoProvenienza(),
      });
      trackMetodo("modulo");
      setDone(true);
    } catch {
      setErr("Invio non riuscito. Riprova tra poco oppure scrivimi su WhatsApp.");
    } finally {
      setSending(false);
    }
  };

  if (done) {
    return (
      <div className="mk-ok" data-testid="metodo-form-success" role="status">
        <h3>Grazie, {form.nome.trim().split(" ")[0]}.</h3>
        <p>Ho ricevuto la tua richiesta. {RICONTATTO}</p>
      </div>
    );
  }

  return (
    <form className="mk-form" onSubmit={submit} noValidate data-testid="metodo-form">
      <label className="f">Nome
        <input type="text" autoComplete="name" value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} data-testid="metodo-form-nome" />
      </label>
      <label className="f">Telefono
        <input type="tel" autoComplete="tel" inputMode="tel" value={form.telefono} onChange={(e) => setForm({ ...form, telefono: e.target.value })} data-testid="metodo-form-telefono" />
      </label>
      <label className="f"><span>Cosa vorresti costruire per te? <span className="opt">(facoltativo)</span></span>
        <textarea value={form.domanda} maxLength={600} onChange={(e) => setForm({ ...form, domanda: e.target.value })} data-testid="metodo-form-domanda" />
      </label>
      <label className="chk">
        <input type="checkbox" checked={form.privacy} onChange={(e) => setForm({ ...form, privacy: e.target.checked })} data-testid="metodo-form-privacy" />
        <span>Ho letto l'<Link to="/privacy" target="_blank" data-testid="metodo-form-privacy-link">informativa privacy</Link> e acconsento al trattamento dei miei dati per essere ricontattato in merito alla mia richiesta.</span>
      </label>
      {err && <p className="err" role="alert" data-testid="metodo-form-error">{err}</p>}
      <button type="submit" className="mk-btn" disabled={sending} data-testid="metodo-form-submit">{sending ? "Invio in corso…" : "Parliamo del tuo progetto"}</button>
      <p className="how" data-testid="metodo-form-ricontatto">{RICONTATTO}</p>
    </form>
  );
}

function Chiusura({ calcHref }) {
  return (
    <section className="mk-final" id="contatto" data-testid="metodo-finale">
      <div className="mk-w">
        <h2>Cosa vorresti aver costruito per te, tra qualche anno?</h2>
        <p className="mk-sub">Partiamo dalla tua situazione e dalle tue domande. Nel primo confronto valuteremo insieme se il Metodo Alex Gold può essere adatto al tuo progetto.</p>
        <ContactForm />
        <div className="mk-alt">
          <p>Preferisci scrivermi? <a href={WHATSAPP_LINK} onClick={() => trackMetodo("whatsapp")} target="_blank" rel="noopener noreferrer" className="mk-link" data-testid="metodo-whatsapp-btn">Contattami su WhatsApp</a></p>
          <p>Vuoi partire dai numeri? <a href={calcHref} onClick={() => trackMetodo("calcolatore")} className="mk-link" data-testid="metodo-calcolatore-btn-2">Prova il calcolatore gratuito.</a></p>
        </div>
        <p className="mk-disc">Alex Gold collabora con operatori autorizzati OAM. L'oro fisico non è uno strumento finanziario: il suo prezzo può salire o scendere e non sono garantiti rendimenti né la conservazione del capitale. La "liquidazione personale" è un'espressione figurata e non un TFR in senso giuridico. I contenuti di questa pagina hanno finalità informative.</p>
      </div>
    </section>
  );
}

export default function Metodo() {
  useEffect(() => {
    document.title = "Metodo Alex Gold";
    trackMetodo("visita");
    const prev = document.body.style.background;
    document.body.style.background = GREEN;
    return () => { document.body.style.background = prev; };
  }, []);

  const calcHref = useMemo(() => {
    const qs = window.location.search;
    return qs && qs.length > 1 ? `/calcolatore${qs}` : "/calcolatore?utm_source=metodo&utm_medium=cta";
  }, []);

  return (
    <div className="mk" data-testid="metodo-page">
      <style>{CSS}</style>
      <Hero calcHref={calcHref} />
      <Bisogno />
      <ComeFunziona />
      <Accompagnamento />
      <Testimonianze />
      <ChiTiAccompagna />
      <Chiusura calcHref={calcHref} />
    </div>
  );
}
